"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CacheForTime = exports.CacheableResult = exports.CacheV2Synchronized = exports.CacheV2 = exports.Cache = void 0;
var cache_1 = require("./cache");
Object.defineProperty(exports, "Cache", { enumerable: true, get: function () { return cache_1.Cache; } });
var cacheV2_1 = require("./cacheV2");
Object.defineProperty(exports, "CacheV2", { enumerable: true, get: function () { return cacheV2_1.CacheV2; } });
var synchronized_1 = require("./synchronized");
Object.defineProperty(exports, "CacheV2Synchronized", { enumerable: true, get: function () { return synchronized_1.CacheV2Synchronized; } });
var utils_1 = require("./utils");
Object.defineProperty(exports, "CacheableResult", { enumerable: true, get: function () { return utils_1.CacheableResult; } });
Object.defineProperty(exports, "CacheForTime", { enumerable: true, get: function () { return utils_1.CacheForTime; } });
//# sourceMappingURL=index.js.map